import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';

export const TooltipButton = ({ title, onClick, children }) => (
  <InfoTooltip content={title} showArrow>
    <button type="button" onClick={onClick} aria-label={`${title}-button`}>
      {children}
    </button>
  </InfoTooltip>
);
